/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasTemplateCellContainer = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasTemplateCellContainer, _super);
    function CanvasTemplateCellContainer(a) {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.c = null;
        _this._opacity = 0;
        _this.c = a;
        return _this;
    }
    Object.defineProperty(CanvasTemplateCellContainer.prototype, "isCanvasBased", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasTemplateCellContainer.prototype, "opacity", {
        get: function () {
            return this._opacity;
        },
        set: function (a) {
            this._opacity = a;
        },
        enumerable: true,
        configurable: true
    });
    CanvasTemplateCellContainer.$t = markType(CanvasTemplateCellContainer, 'CanvasTemplateCellContainer');
    return CanvasTemplateCellContainer;
}(Base));
export { CanvasTemplateCellContainer };
//# sourceMappingURL=CanvasTemplateCellContainer.js.map
